module.exports = __webpack_public_path__ + "static/media/XD.c8b85581.svg";